module.exports = __webpack_public_path__ + "img/button_EndoTower.0cbabb69.svg";